import classes from "./Footer.module.css";
import instagram from "../assets/svg/instagram.svg";
import github from "../assets/svg/github.svg";
import linkedin from "../assets/svg/linkedin.svg";

const Footer = () => {
  return (
    <div className={classes.footer}>
      <p>
        © This Website is Copyrighted by Abhishek Chamoli 2022. The design and
        development of this website is all related to Abhishek Chamoli.
      </p>
      <div className={classes.links}>
        <span>
          <p>Instagram</p>
          <a href="https://www.instagram.com/abhishekchamoli_official/?hl=en">
            <img src={instagram} />
          </a>
        </span>
        <span>
          <p>Git-hub</p>
          <a href="https://github.com/AbhishekChamoliDeveloper">
            <img src={github} />
          </a>
        </span>
        <span>
          <p>Linkedin</p>
          <a href="https://www.linkedin.com/in/abhishek-chamoli/">
            <img src={linkedin} />
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;
